module.exports = __webpack_public_path__ + "img/BadgeIcon.7bc845f3.svg";